import { studentsActions } from './students-slice';
import store from './index' 
import { handleError, handleSessionExpired } from './error-handler';
import { beginSchoolListFetch, commitSchoolListFetch } from './school-actions';


export const fetchStudentsList = (currentPage = 1, orderBy = 9, desc = false) => {
    return async (dispatch) => {
        const revisionAtStart = beginSchoolListFetch()
        const fetchData = async () => {
            dispatch(studentsActions.setIsLoading(true))
            const bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(`${url}api/students/simple`, {
                method: 'POST',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    currentPage: currentPage,
                    orderBy: orderBy,
                    desc: desc  
                })
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch students list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const studentsData = await fetchData()
            if (!commitSchoolListFetch(dispatch, 'students', revisionAtStart)) return
            // If loading page 1, replace; otherwise append (for load more)
            if (currentPage === 1) {
                dispatch(studentsActions.loadStudents({ students: studentsData || [] }))
            } else {
                dispatch(studentsActions.appendStudents({ students: studentsData || [] }))
            }
        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(studentsActions.setIsLoading(false))
        }
    };
};

export const fetchStudentsListWithFilter = (filterObject) => {
    return async (dispatch) => {
        const revisionAtStart = beginSchoolListFetch()
        const fetchData = async () => {
            dispatch(studentsActions.setIsLoading(true))
            const bearer = 'Bearer ' + localStorage.getItem('token');
            const baseUrl = store.getState().auth.url
            const url = `${baseUrl}api/students/filtered`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filterObject)
            });
            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch students list with filter.') }
            }
            const data = await response.json()
            return data;
        }
        try {
            const studentsData = await fetchData()
            if (!commitSchoolListFetch(dispatch, 'students', revisionAtStart)) return
            const currentPage = filterObject.currentPage || 1;
            const currentStudents = store.getState().students.students;
            
            // If loading page 1 or we have no students, replace; otherwise append (for load more)
            if (currentPage === 1 || currentStudents.length === 0) {
                dispatch(studentsActions.loadStudents({ students: studentsData || [] }))
            } else {
                dispatch(studentsActions.appendStudents({ students: studentsData || [] }))
            }
        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(studentsActions.setIsLoading(false))
        }
    }
};

export const fetchStudentDetails = (studentId) => {
    return async (dispatch) => {
        const fetchData = async () => {
            const bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(`${url}api/students/${studentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch student details.') }
            }
            const data = await response.json()
            return data;
        }
        try {
            const studentData = await fetchData()
            dispatch(studentsActions.setSelectedStudent(studentData))
        } catch (error) {
            handleError(dispatch, error)
        }
    }
};

// Parent Login Portal - uses api/parentstudents endpoints. When donorId is passed (school user on behalf), fetches that parent's students.
export const fetchParentStudentsList = (donorId = null, parentLoginSettingId = 0) => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(studentsActions.setIsLoading(true))
            console.log('fetchParentStudentsList', donorId)
            const bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            let query = donorId != null && donorId > 0 ? `?donorId=${donorId}` : ''
            if(parentLoginSettingId > 0){
                query += `&parentLoginSettingId=${parentLoginSettingId}`
            }
            const response = await fetch(`${url}api/parentstudents${query}`, {
                method: 'GET',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch parent students list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const studentsData = await fetchData()
            dispatch(studentsActions.loadStudents({ students: studentsData || [] }))
        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(studentsActions.setIsLoading(false))
        }
    };
};

